import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s2_mobile h-100p px-7" }
const _hoisted_4 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s4_mobile h-100p px-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "s3_mobile h-100p px-2" }
const _hoisted_9 = { class: "font-normal mb-5" }
const _hoisted_10 = { class: "s7_mobile h-100p px-5" }
const _hoisted_11 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_12 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_13 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_14 = { class: "s20 gap-6 px-5 pb-8 collapse-content active" }
const _hoisted_15 = { class: "flex items-center gap-6" }
const _hoisted_16 = { class: "s7" }
const _hoisted_17 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_18 = { class: "s7" }
const _hoisted_19 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_20 = { class: "s6" }
const _hoisted_21 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_22 = { class: "s6" }
const _hoisted_23 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_24 = { class: "s6" }
const _hoisted_25 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }

import { calculatePercentage } from '@/utils';
import { computed, inject, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import CollectivitesCartesTableComponent from './@components/CollectivitesCartesTableComponent.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesCartesView',
  setup(__props) {

const BACKEND_URL = inject('BACKEND_URL');
const route = useRoute();
const startup_infos: any = (route.meta as any).item;
const collectivite = ref<any>((route.meta as any).item.collectivite || {});
const stats = ref<{
    total: number,
    active: number,
    delivered: number,
    delivering: number,
    disabled: number,
    inactive: number,
    pending: number,
    withdrawn: number
}>((route.meta as any).item.stats || {
    total: 0,
    active: 0,
    delivered: 0,
    delivering: 0,
    disabled: 0,
    inactive: 0,
    pending: 0,
    withdrawn: 0
});
//const users = ref<any[]>((route.meta as any).item.users);

const membersPercentage = computed(() => {
    const maxMembers = 50000; // Valeur par défaut pour la barre de progression
    return Math.min(100, calculatePercentage(collectivite.value.users_count, maxMembers));
});

return (_ctx: any,_cache: any) => {
  const _component_FinancePrelevementsDecaissements = _resolveComponent("FinancePrelevementsDecaissements")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Collectivité / Cartes <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Collectivités</span><span class=\"btn shadow-200 white2\">Statistiques</span><span class=\"btn shadow-200 white2\">Gérer les cartes</span><span class=\"btn shadow-200 white2\">Prélèvements / Décaissements</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: collectivite.value.logo ? (_unref(BACKEND_URL) + '/assets/collectivites/' + collectivite.value.logo) : '/assets/logos/logo2.svg',
            width: "100%"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h4", _hoisted_7, _toDisplayString(collectivite.value.nom || ''), 1),
        _createElementVNode("h3", null, _toDisplayString(collectivite.value.rccm || 'N/A'), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h4", _hoisted_9, _toDisplayString(collectivite.value.users_count || 0) + " / 50000 Membres", 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "s4_mobile h-100p px-3" }, [
        _createElementVNode("h4", { class: "font-normal" }, [
          _createTextVNode(" Date de souscription "),
          _createElementVNode("br", { class: "mb-2" }),
          _createElementVNode("b", { class: "text-2xl" }, "11 Janvier 2028")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, "Membres " + _toDisplayString(collectivite.value.users_count ? Math.round((collectivite.value.users_count / 50000) * 100) : 0) + "%", 1),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
            style: _normalizeStyle({ width: membersPercentage.value + '%' })
          }, _toDisplayString(collectivite.value.users_count || 0) + " / 50000 ", 5)
        ])
      ])
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createElementVNode("div", _hoisted_13, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }, [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Gestion des cartes ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_14, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-black" }),
              _createTextVNode(" Cartes créées ")
            ], -1)),
            _createElementVNode("h1", _hoisted_17, _toDisplayString((stats.value.total || 0) + '/' + (collectivite.value.users_count || 0)), 1),
            _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "92%", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-black",
                style: {"width":"92%"}
              }, " 92% ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
              _createTextVNode(" Cartes en livraison ")
            ], -1)),
            _createElementVNode("h1", _hoisted_19, _toDisplayString((stats.value.delivering || 0) + '/' + (collectivite.value.users_count || 0)), 1),
            _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "56.4%", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                style: {"width":"56.4%"}
              }, " 56.4% ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-green-light" }),
              _createTextVNode(" Cartes livrées ")
            ], -1)),
            _createElementVNode("h1", _hoisted_21, _toDisplayString((stats.value.delivered || 0) + '/' + (collectivite.value.users_count || 0)), 1),
            _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                style: {"width":"100%"}
              }, " 100% ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-green-light" }),
              _createTextVNode(" Cartes retirées ")
            ], -1)),
            _createElementVNode("h1", _hoisted_23, _toDisplayString((stats.value.withdrawn || 0) + '/' + (collectivite.value.users_count || 0)), 1),
            _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                style: {"width":"100%"}
              }, " 100% ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-green-light" }),
              _createTextVNode(" Cartes activées ")
            ], -1)),
            _createElementVNode("h1", _hoisted_25, _toDisplayString((stats.value.active || 0) + '/' + (collectivite.value.users_count || 0)), 1),
            _cache[16] || (_cache[16] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
            _cache[17] || (_cache[17] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                style: {"width":"100%"}
              }, " 100% ")
            ], -1))
          ])
        ])
      ])
    ]),
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createVNode(CollectivitesCartesTableComponent, { collectivite: collectivite.value }, null, 8, ["collectivite"]),
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createVNode(_component_FinancePrelevementsDecaissements, { "startup-infos": _unref(startup_infos) }, null, 8, ["startup-infos"]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "clear-both h-50" }, null, -1)),
    _createVNode(ConfirmationModal, { ref: "confirmationModalRef" }, null, 512)
  ]))
}
}

})